import { useMemo, RefObject } from 'react';
import { usePricingContext } from 'services/contexts/PricingContext';
import {
  type IPrice,
  type IProduct,
  ProductType,
} from 'services/api/entities/stripe';
import {
  PlanInfo,
  PriceBoxHeader,
  PriceTag,
  SelectPlanButton,
} from './components';
import { getMonthlyPrice, getYearlyPrice } from './helpers';
import { StyledPricingContainer, StyledPlanInfo } from './styled';

type PropsType = {
  product: IProduct;
  distributionRef: RefObject<HTMLDivElement>;
  onClick: (price: IPrice | null) => void;
};

const PricingSection = ({ product, distributionRef, onClick }: PropsType) => {
  const { isAnnualPaymentSelected } = usePricingContext();

  const { information, prices } = product;
  const { title, productType } = information;

  const productPrice = useMemo(() => {
    if (productType === ProductType.Free) {
      return null;
    }
    if (isAnnualPaymentSelected) {
      return getYearlyPrice(prices);
    }
    return getMonthlyPrice(prices);
  }, [isAnnualPaymentSelected, prices, productType]);

  return (
    <StyledPricingContainer>
      <PriceBoxHeader title={title} productType={productType} />
      <StyledPlanInfo>
        <PriceTag price={productPrice} />
        <PlanInfo product={product} distributionRef={distributionRef} />
        <SelectPlanButton
          productType={productType}
          onClick={() => onClick(productPrice)}
        />
      </StyledPlanInfo>
    </StyledPricingContainer>
  );
};

export default PricingSection;
